import { css } from 'styled-components';
import { outlined } from 'components/Button/styles/variants';
import { BaseButtonProps } from 'types';
import { buttonBorderRadiusBySizeDecorator } from 'utils';

export const roundOutlinedButton = ({
	background,
	...rest
}: BaseButtonProps) => css`
	${outlined(rest)}
	line-height: 2.4rem;
	${buttonBorderRadiusBySizeDecorator(rest)}
`;
